import {ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ContentType} from '../engine/playable/playable';
import {WebsocketService} from '../engine/websocket.service';
import {AnalyticsService} from '../modules/analytics/analytics.service';
import {SettingsStoreService} from './settings-store.service';
import {fromEvent} from 'rxjs';
import {throttleTime} from 'rxjs/operators';
import {Store} from '@ngxs/store';
import {AppendPlayableLog, Init, RequestApi, ToggleUI} from '../store/player.actions';

@Component({
  selector: 'gg-player',
  templateUrl: 'player.component.html',
  styleUrls: ['../../../styles/gg-player-new.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [Store]
})
export class PlayerComponent implements OnInit, OnChanges, OnDestroy {
  @Input() src: string;
  @Input() type: string;
  @Input() embeded: any = false;
  @Input() autostart: any = false;
  @Input() poster: string;
  // @Input() volume: number;
  @Input() data: {} = {};

  public isUIVisible$ = this.store.select(state => state.player.isUIVisible);
  private uiTimer: any;

  constructor(
    public elementRef: ElementRef,
    private store: Store,
    private settingsStore: SettingsStoreService,
    private ws: WebsocketService,
    private analytics: AnalyticsService,
  ) {
  }

  ngOnChanges(): void {
    if (!this.src) {
      return;
    }

    const contentType = this.type ? this.type.toLowerCase() : ContentType.MP4;
    const savedSettings = this.settingsStore.getSettings();

    // console.log(savedSettings);

    this.ws.channel = this.src;

    let isTruthy = value => value != false && value != 'false' && value != 0;

    const initState = {
      ...savedSettings,
      src: this.src,
      isEmbeded: isTruthy(this.embeded),
      autoplay: isTruthy(this.autostart),
      contentType: contentType,
      poster: this.poster,
      apiData: this.data
    };

    // console.log('initState', {initState});
    this.store.dispatch(new Init(initState));
    this.store.dispatch(new AppendPlayableLog('Welcome!'));

    if (contentType === ContentType.HLS) {
      this.store.dispatch(new AppendPlayableLog('contentType:' + contentType));
      this.store.dispatch(new RequestApi({streamkey: this.src}));
    }
  }

  ngOnInit() {
    this.analytics.attach();

    fromEvent(this.elementRef.nativeElement, 'mousemove')
      .pipe(throttleTime(500))
      .subscribe(() => this.mouseMoved());

    this.elementRef.nativeElement.addEventListener('mouseenter', () => this.mouseMoved());
    this.elementRef.nativeElement.addEventListener('mouseleave', () => this.mouseLeft());
  }

  mouseMoved() {
    if (this.uiTimer) {
      clearTimeout(this.uiTimer);
    }
    this.store.dispatch(new ToggleUI({state: true}));

    this.uiTimer = setTimeout(() => {
      this.store.dispatch(new ToggleUI({state: false}));
    }, 3000);
  }

  mouseLeft() {
    if (this.uiTimer) {
      clearTimeout(this.uiTimer);
    }
    this.store.dispatch(new ToggleUI({state: false}));
  }

  ngOnDestroy(): void {
    this.ws.destroy();
    this.analytics.ngOnDestroy();
  }


}
